import { useScreenMessage } from '@gogame/screens';

import { loadQlikSense } from 'scenes/QlikSense/sources/qlikSense';

export const useQlikSense = () => {
  const { showErrorMessage } = useScreenMessage();
  return params =>
    loadQlikSense(params).catch(e => {
      showErrorMessage(e.message);
      return Promise.reject(e);
    });
};
